<template>
  <div>
    <v-dialog/>
    <div class="class_add_top">
      <a onclick="history.go(-1)" class="back">返回</a>
    </div>
    <div style="padding: 0 10px;">
      <div class="highlight_title">
        {{form.name}} - 签到情况
      </div>
      <!--右侧内容-->
      <div class="gj_list" style="min-height: 600px;">
        <h5 class="none_ts" v-if="lists.length == 0">
          <img src="@/assets/images/none_data.jpg" alt="">
          <h4>暂无报名人员签到情况</h4>
        </h5>
        <el-table v-if="lists && lists.length > 0"
                  :data="lists" stripe border
                  style="width: 100%">
          <el-table-column
            label="姓名"
            width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.members">{{scope.row.members[0].name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(value, key, index) in signMap" :key="key" :label="key">
            <template slot-scope="scope">
              <div v-if="scope.row.signMap[key].id">
                <div>签到地点: {{scope.row.signMap[key].signSite}}</div>
                <div>签到时间: {{scope.row.signMap[key].signTime}}</div>
              </div>
              <el-button v-debounce-click @click.stop="sign($route.params.id, key, scope.row.userId)" size="mini" v-if="!scope.row.signMap[key].id">补签到</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="onsite_list_bottom mtf30">
        <div v-if="cntData > 0">共<b>{{cntData}}</b>条报名信息</div>
        <div v-if="cntData > 0">
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </div>
      </div>
      <!--/右侧内容-->
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import Vue from 'vue'
  import Paginate from 'vuejs-paginate'
  import ModalBox from '@/components/common/modal/index.vue'
  import rangeManip from '@/components/byl/rangeManip/withInputs.vue'
  import utils from '@/utils'
  import { getCookie } from '@/utils/cookies'
  export default {
    components: { Paginate },
    mounted () {
      this.getModel(this.$route.params.id)
      this.getName(this.$route.params.id)
    },
    data () {
      return {
        filters: {
          pageNo: 1,
          pageSize: 12
        },
        form: {},
        lists: [],
        signMap: {},
        cntData: 0,
        pages: 0,
        prefix: this.$route.meta.prefix || ''
      };
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.getModel(this.$route.params.id)
      },
      getModel (id) {
        var that = this
        api.post(config.enrollApiPath, '/signupuser/signInFindList', { 	signUpId: id, pageNo: this.filters.pageNo, pageSize: this.filters.pageSize }, function (r) { // 正常
          if (r.data) {
            that.lists = (r.data.signupuserList) ? r.data.signupuserList : []
            that.signMap = (r.data.signupuserList) ? r.data.signupuserList[0].signMap : {}
            that.cntData = r.cntData // 总数
            that.pages = Math.ceil(r.cntData / that.filters.pageSize) // 页数
          }
        })
      },
      getName (id) {
        var that = this
        api.get(config.enrollApiPath, '/signupinfo/get', { id: id }, function (r) { // 正常
          that.form = r.data
        })
      },
      sign (signupid, date, uid) {
        var that = this
        if (signupid) {
          this.confirmBox({
            title: '补签到',
            text: '确认补签吗?',
            yes: function () {
              api.post(config.enrollApiPath, '/signupuser/updateSignInfo', { signUpId: signupid, signTime: utils.dateFormat(new Date(date), 'yyyy-MM-dd hh:mm:ss'), uid: uid }, (r) => { // 正常
                that.$toasted.show('补签成功')
                that.getModel(that.$route.params.id)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  .xo-table-btn {
    padding: 5px;
    background-color: #ff3633;
    color: white;
    border-radius: 5px;
    cursor: pointer;
  }
  .highlight_title {
    height: 60px;
    line-height: 60px;
    background: #fcca75;
    text-align: center;
    font-weight: normal;
    margin-top: 10px;
    color: #fff;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/enroll/signin.vue